import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLocalStorageValue } from '@react-hookz/web';
import { T } from 'gt-react';
import {
  EntityDetailTabsProvider,
  EntityDetailTabsHeader,
  EntityDetailTabsContent,
  useEntityDetailTabsContext,
} from '@/components/system-entities/entity-detail-tabs';
import { SystemEntity } from '@erp/shared-types';
import { Tabs } from '@/components/ui/tabs';

function SalesOrderDetailTabsWrapper() {
  const { activeTabId, setActiveTabId } = useEntityDetailTabsContext();
  return (
    <Tabs
      value={activeTabId}
      onValueChange={setActiveTabId}
      className="flex flex-col flex-1 min-h-0"
    >
      <SheetHeader className="shrink-0 grow-0 border-b px-3 py-3">
        <SheetTitle className="sr-only">
          <T context="accessible title for the sales order detail slide-in panel">
            Sales Order Details
          </T>
        </SheetTitle>
        <EntityDetailTabsHeader />
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <EntityDetailTabsContent />
      </div>
    </Tabs>
  );
}

export function SalesOrderDetailSlidein({
  isOpen,
  onOpenChange,
  salesOrderId,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  salesOrderId?: string;
}) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('sales-order-detail-view-size', {
      defaultValue: 50,
    });

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        hideCloseButton
        resizableProps={{
          defaultSize: detailViewSize,
          onResize: setDetailViewSize,
          className: 'flex flex-col',
        }}
      >
        {salesOrderId ? (
          <EntityDetailTabsProvider
            initialEntity={{
              entityType: SystemEntity.AR_SALES_ORDER,
              entityId: salesOrderId,
            }}
          >
            <SalesOrderDetailTabsWrapper />
          </EntityDetailTabsProvider>
        ) : (
          <>
            <SheetHeader className="shrink-0 grow-0">
              <SheetTitle>
                <T context="title for the sales order detail slide-in panel">
                  Sales Order Details
                </T>
              </SheetTitle>
            </SheetHeader>
            <div className="p-4 text-sm text-muted-foreground">
              <T context="placeholder text shown when no sales order is selected in the sales order detail panel">
                No sales order selected
              </T>
            </div>
          </>
        )}
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            <T context="button label to close the sales order detail panel">
              Close
            </T>
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
